import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-socialmedia-dialog',
  templateUrl: './socialmedia-dialog.component.html',
  styleUrls: ['./socialmedia-dialog.component.css']
})
export class SocialmediaDialogComponent implements OnInit {

  public repoUrl = 'https://ingeniouskey.com';
  public imageUrl = 'https://ingeniouskey.com/img/imagotipo_ik.png';
  public text = 'BIENVENIDOS A INGENIOUS KEY Somos una firma digital con años de experiencia y con un grupo de personas ingeniosas.';
  public hashtags = 'ik, todoik';
  
  constructor(public dialogRef: MdDialogRef<SocialmediaDialogComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/socialmedia-dialog/socialmedia-dialog.component.ts